var _path, _rect, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 80,
    viewBox: "0 0 211 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1194 34.634L0 56.8221L32.1194 79.0103V71.0103H71L120 26.0112V26.0002H211V0.000236511H120V0.0112305L71 45.0103H32.1194V34.634Z",
    fill: "url(#paint0_linear_3634_4719)",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.8398,
    y: 40.8364,
    width: 25.0453,
    height: 24,
    transform: "rotate(-47.3665 73.8398 40.8364)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.826 56.3793L178.707 34.1911V44.9999H111V44.9989L62 -0.000106812H0V25.9999H62L111 70.9989V70.9999H178.707V78.5674L210.826 56.3793Z",
    fill: "url(#paint1_linear_3634_4719)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3634_4719",
    x1: 211,
    y1: 79.0103,
    x2: 0,
    y2: 79.0103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435765,
    stopColor: "#FFD03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687136,
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3634_4719",
    x1: 200.5,
    y1: 78.5674,
    x2: 9.99998,
    y2: 78.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435765,
    stopColor: "#FFD03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687136,
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoArrows);
export default __webpack_public_path__ + "static/media/two-arrows.32f84d584d5ea48258c86713d62f7ab3.svg";
export { ForwardRef as ReactComponent };